import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import "./css/app.css";
import Header from "./components/Header";
import Login from "./components/Login";
import Loading from "./components/Loading";
import { setKey, getKey, clearKeys } from "./store/actions";
import keys from "./store/keys";
import ResetPassword from "./components/ResetPassword";
import Users from "./components/Users";
import UserDetails from "./components/UserDetails";
import Ads from "./components/Ads";
import AdDetails from "./components/AdDetails";
import UserReports from "./components/UserReports";
import UserReportDetails from "./components/UserReportDetails";
import AdReports from "./components/AdReports";
import AdReportDetails from "./components/AdReportDetails";
import Manage from "./components/Manage";
import Stats from "./components/Stats";
import Chats from "./components/Chats";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import Invoices from "./components/Invoices";
import OfficialProducts from "./components/OfficialProducts";
import ServicesManagement from "./components/ServicesManagement";
import WantedModeration from "./components/WantedModeration";

function App({ session, setKey }) {
	const { t, i18n } = useTranslation();

	/* Apply the persisted language + text direction on load and whenever it changes,
	   so the admin opens in the language the user last chose (Arabic by default). */
	useEffect(() => {
		const language = session.language || "ar";
		if (i18n.language !== language) i18n.changeLanguage(language);
		const dir = language === "en" ? "ltr" : "rtl";
		document.getElementsByTagName("html")[0].setAttribute("dir", dir);
	}, [session.language, i18n]);

	/* Function handles logout logic passed to sidebar */
	const handleLogout = e => {
		e.preventDefault();
		const Cookies = require("universal-cookie").default;
		if (session.cookie) {
			const cookies = new Cookies();
			cookies.remove(session.cookie);
		}
		clearKeys();
		setKey(keys.isLoggedIn, false);
		window.location.href = "/";
	};

	return (
		<BrowserRouter>
			{session.isLoading && <Loading />}
			{session.showLogin && <Login />}
			{session.showResetPassword && <ResetPassword />}

			{/* If NOT logged in, show Header (or nothing/Login) - Keeping old Header for non-logged in state if needed, or just Login screen */}
			{/* Actually, if not logged in, system shows "Please login". Let's keep logic simple. */}

			{session.isLoggedIn === false ? (
				<>
					<Header /> {/* Can keep old header for public/login view only */}
					<div className="container mt-5 text-center">
						<div className="card-modern d-inline-block p-5">
							<h3>{t("admin_panel_access")}</h3>
							<p className="text-muted-modern mb-4">{t("must_authenticate")}</p>
							<button className="btn-modern btn-primary-modern" onClick={() => setKey(keys.showLogin, true)}>
								{t("login_to_dashboard")}
							</button>
						</div>
					</div>
				</>
			) : (
				/* LOGGED IN LAYOUT */
				<div className="d-flex">
					<Sidebar session={session} handleLogout={handleLogout} />

					<div className="main-content-wrapper w-100">
						<Topbar />

						<div className="page-content">
							<Switch>
								<Route exact path="/" component={Users} />
								<Route exact path="/users" component={Users} />
								<Route
									exact
									path="/users/:userId"
									component={UserDetails}
								/>
								<Route exact path="/ads" component={Ads} />
								<Route exact path="/ads/:adId" component={AdDetails} />
								<Route exact path="/official-products" component={OfficialProducts} />
								<Route exact path="/user-reports" component={UserReports} />
								<Route
									exact
									path="/user-reports/:reportId"
									component={UserReportDetails}
								/>
								<Route exact path="/ad-reports" component={AdReports} />
								<Route
									exact
									path="/ad-reports/:reportId"
									component={AdReportDetails}
								/>
								<Route exact path="/chats" component={Chats} />
								<Route exact path="/manage/services" component={ServicesManagement} />
								<Route exact path="/manage/wanted" component={WantedModeration} />
								<Route path="/manage" component={Manage} />
								<Route path="/stats" component={Stats} />
								<Route exact path="/invoices" component={Invoices} />
							</Switch>
						</div>
					</div>
				</div>
			)}
		</BrowserRouter>
	);
}

const mapStateToProps = store => ({
	session: store.session
});

const mapDispatchToProps = dispatch => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
	getKey: key => dispatch(getKey(key)),
	clearKeys: () => dispatch(clearKeys())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
